var $window = $(window);
var breakPoint = 1024;

var resizeFlag = false;
var windowWidth = $window.width();
var windowHeight = $window.height();

//ローディング
// import {loading} from "../include/module";
// loading();

//ヘッダーの開閉
import {headerHamburger} from "../include/module";
headerHamburger();

//ページ内リンクのアニメーション
import {anchorLink} from "../include/module";
anchorLink();

// preload
import {scrollMagic} from "../include/module";
scrollMagic();

import {fadeImage} from "../include/module";
fadeImage();

import {menuCurrent} from "../include/module";
menuCurrent();

import {approachSlide} from "../include/module";
approachSlide();


// resizing
// import {resizing} from "../include/module";
// resizing();

// アニメーション
// import {animationFire} from "../include/module";
// animationFire();



// WEBPACK FOOTER //
// ./src/assets/js/index/script.js